import HttpService from "./HttpService";
import Logger from "../Logger/Logger";
import {SERVER_URL} from "../../Config/Parameters";
import HttpResult from "../Models/HttpResult";
import {userRepository} from "../Repositories/UserRepository";
import User from "../Models/User";
import UserResponse from "../Models/UserResponse";

const logger = Logger.Create('UserService');

/**
 * The User Service.
 */
export default class UserService
{
    /**
     * Requests the server to login.
     */
    public static async login(user: User): Promise<HttpResult>
    {
        const actionCallback: HttpResult = {
            success: false,
            message: "",
        };
        
        const url = `${SERVER_URL}/authentication/login`;
        
        logger.info(`Logging in...`);

        await HttpService.tokenlessPost<UserResponse>(url, user)
            .then((response) =>
            {
                logger.info('Successfully logged in.');
                actionCallback.success = true;
                userRepository.updateToken(response.token);
            })
            .catch(() =>
            {
                logger.info('Failed to log in.')
            })
        
        return actionCallback;
    }
}